import "./../css/common.scss";
import { EventEmitter } from 'fbemitter';
import GLightbox from 'glightbox';
import Selects from './components/selects';
import PhotoUploader from './modules/PhotoUploader';
import Animations from './modules/animations';
import BasketFunctions from './modules/basketFunctions';
import ColourChipLighting from './modules/colourChipLighting';
import ColourChipListing from './modules/colourChipListing';
import ColourChip from './modules/colourChipPopup';
import ColourSelection from './modules/colourSelection';
import ColourSubcategoryCarousel from "./modules/colourSubcategoryCarousel";
import FindAConsultant from "./modules/findAConsultant";
import FindAConsultantTrade from "./modules/findAConsultantTrade";
import ColourWheel from './modules/colourWheel';
import Content from './modules/content';
import CoverageCalc from './modules/coverageCalculator';
import FAQ from './modules/faq';
import Forms from './modules/forms';
import Heros from './modules/heros';
import LazyGoogleMaps from './modules/lazyGoogleMaps';
import LazyLoadImages from './modules/lazyLoadImages';
import Navigation from './modules/navigation';
import GlobalPopupCookies from './modules/popupCookies';
import ProductPopup from './modules/productPopup';
import ColourDetailBuy from './modules/colourDetailBuy';
import RedirectModal from './modules/redirectModal';
import searchBar from './modules/search';
import Sliders from './modules/sliders';
import Tabs from './modules/tabs';
import ChatNowPopup from './modules/chatNowPopup';
import HubHeader from './components/hub-header';
import Dropdown from './components/dropdown';
import ShareModal from './components/share-modal';
import { initLoginDropdown } from './modules/login-dropdown';
import { initEditCollectionMenu } from './modules/edit-collection-menu'
import { initLoginErrors } from './modules/login-errors';
import CollectionImageForm from './modules/collectionImageForm';
import MyDashboard from './modules/myDashboard';
import MyProfile from './modules/myProfile';
import Onboarding from './modules/onboarding';
import { initCollectionLikeButtons } from './modules/likeCollection';
import initCheckboxLimiter from './components/checkbox-limiter';
import initShowToastSystem from './components/show-toast';
import initShowTooltip from "./components/show-tooltip";

window.emitter = new EventEmitter();

try { Sliders(); } catch (error) { console.error('Error in Sliders:', error); }
try { LazyLoadImages(); } catch (error) { console.error('Error in LazyLoadImages:', error); }
try { LazyGoogleMaps(); } catch (error) { console.error('Error in LazyGoogleMaps:', error); }
try { FAQ(); } catch (error) { console.error('Error in FAQ:', error); }
try { Tabs(); } catch (error) { console.error('Error in Tabs:', error); }
try { Animations(); } catch (error) { console.error('Error in Animations:', error); }
try { searchBar(); } catch (error) { console.error('Error in searchBar:', error); }
try { Navigation(); } catch (error) { console.error('Error in Navigation:', error); }
try { colourCard(); } catch (error) { console.error('Error in colourCard:', error); }
try { CoverageCalc(); } catch (error) { console.error('Error in CoverageCalc:', error); }
try { RedirectModal(); } catch (error) { console.error('Error in RedirectModal:', error); }
try { ColourChip(); } catch (error) { console.error('Error in ColourChip:', error); }
try { Heros(); } catch (error) { console.error('Error in Heros:', error); }
try { BasketFunctions(); } catch (error) { console.error('Error in BasketFunctions:', error); }
try { ColourChipListing(); } catch (error) { console.error('Error in ColourChipListing:', error); }
try { ColourChipLighting(); } catch (error) { console.error('Error in ColourChipLighting:', error); }
try { ColourSubcategoryCarousel(); } catch (error) { console.error('Error in ColourSubcategoryCarousel:', error); }
try { Selects(); } catch (error) { console.error('Error in Selects:', error); }
try { ProductPopup(); } catch (error) { console.error('Error in ProductPopup:', error); }
try { ColourDetailBuy(); } catch (error) { console.error('Error in ColourDetailBuy:', error); }
try { PhotoUploader(); } catch (error) { console.error('Error in PhotoUploader:', error); }
try { ColourSelection(); } catch (error) { console.error('Error in ColourSelection:', error); }
try { ColourWheel(); } catch (error) { console.error('Error in ColourWheel:', error); }
try { Forms(); } catch (error) { console.error('Error in Forms:', error); }
try { Content(); } catch (error) { console.error('Error in Content:', error); }
try { GlobalPopupCookies(); } catch (error) { console.error('Error in GlobalPopupCookies:', error); }
try { HubHeader(); } catch (error) { console.error('Error in HubHeader:', error); }
try { Dropdown(); } catch (error) { console.error('Error in Dropdown:', error); }
try { initLoginDropdown(); } catch (error) { console.error('Error in initLoginDropdown:', error); }
try { initLoginErrors(); } catch (error) { console.error('Error in initLoginErrors:', error); }
try { ShareModal(); } catch (error) { console.error('Error in ShareModal:', error); }
try { CollectionImageForm(); } catch (error) { console.error('Error in Collection Background Image:', error); }
try { MyDashboard(); } catch (error) { console.error('Error in My Dashboard:', error); }
try { MyProfile(); } catch (error) { console.error('Error in My Profile:', error); }
try { Onboarding(); } catch (error) { console.error('Error in Onboarding:', error); }
try { FindAConsultant(); } catch (error) { console.error('Error in FindAConsultant:', error); }
try { ChatNowPopup(); } catch (error) { console.error('Error in ChatNowPopup:', error); }
try { initEditCollectionMenu(); } catch (error) { console.error('Error in initEditCollectionMenu:', error); }
try { initCollectionLikeButtons(); } catch (error) { console.error('Error in CollectionLikeButtons:', error); }
try { initCheckboxLimiter(); } catch (error) { console.error('Error in initCheckboxLimiter:', error); }
try { initShowToastSystem(); } catch (error) { console.error('Error in initShowToastSystem:', error); }
try { initShowTooltip(); } catch (error) { console.error('Error in initShowTooltip:', error); }
FindAConsultant();
FindAConsultantTrade();
ChatNowPopup();

const lightbox = GLightbox();


if (window.innerWidth < 769) {

    var getMobileBg = document.querySelector('.hero.has-mobile-img');

    if (getMobileBg) {
        getMobileBg.classList.remove("parallax");
        var attr = getMobileBg.getAttribute("data-mobile");

        if (attr != "") {
            getMobileBg.setAttribute("style", attr);
        }
    }
}

function colourCard() {
    var colour = document.querySelectorAll('.colour-card');
    var i;

    for (i = 0; i < colour.length; i++) {
        colour[i].addEventListener("mouseenter", function() {
            var elem = this.children[0];
            var bgColour = elem.style.backgroundColor;
            var borderColour = bgColour.split('(').pop().split(')')[0];
            var boxShadows = "0 0 0 8px rgba(" + borderColour + ', 0.45)';
            elem.style.boxShadow = boxShadows;

            this.addEventListener("mouseleave", function() {
                elem.style.boxShadow = "none";
            });
        });
    }
}
